import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  //.comment-form
  commentFormClass: {
    display: 'flex',
    alignItems: 'flex-end',
    flexFlow: 'column',
    padding: '10px 0',
    position: 'relative',
  },
  //.comment-form .container
  commentFormContainerClass: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: '100%',
  },
  //.comment-form .input-field
  commentFormInputFieldClass: {
    margin: '0 0 0 0',
    width: '100%',
  },
  //.comment-form .input-field mark
  commentFormInputFieldmarkClass: {
    borderRadius: '3px',
    color: 'transparent',
    backgroundColor: '#b1d5e5',
  },
  //.comment-form .actions-container
  commentFormActionsContainerClass: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: '-5px',
  },
  //.comment-form .actions-container .character-limit
  commentFormActionsContainerCharacterLimitClass: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '8px',
  },
  //.comment-form .actions-container .character-limit .circular-progress-buffer
  commentFormActionsContainerCharacterLimitCircularProgressBufferClass: {
    position: 'absolute',
    color: '#b6b6b6',
    ['&.success' as any]: {
      color: '#009358',
    },
    ['&.content' as any]: {
      color: '#1da1f2',
    },
    ['&.finish' as any]: {
      color: '#e0245e',
    },
    ['&.warning' as any]: {
      color: '#ffad1f',
    },
  },
  //.comment-form .actions-container .character-limit .character-count
  commentFormActionsContainerCharacterLimitCharacterCountClass: {
    position: 'absolute',
    fontSize: '0.7rem',
    ['&.success' as any]: {
      color: '#009358',
    },
    ['&.content' as any]: {
      color: '#1da1f2',
    },
    ['&.finish' as any]: {
      color: '#e0245e',
    },
    ['&.warning' as any]: {
      color: '#ffad1f',
    },
  },

  //.comment-form .actions-container .character-limit.content .circular-progress
  commentFormActionsContainerCharacterLimitContentCircularProgressClass: {
    color: '#1da1f2',
  },
}));
